export default class ProviderFile {
    constructor() {
        this.id;
        this.providerId;
        this.fileId;
        this.providerDocumentTypeId;
        this.validUntil;
        this.isVerified;
        this.verifiedByUserId;
        this.verfiedByUser;
    }

    set(setEntity) {
        this.id = setEntity.id;
        this.providerId = setEntity.providerId;
        this.fileId = setEntity.fileId;
        this.providerDocumentTypeId = setEntity.providerDocumentTypeId;
        this.validUntil = setEntity.validUntil;
        this.isVerified = setEntity.isVerified;
        this.verifiedByUserId = setEntity.verifiedByUserId;
        this.verfiedByUser = setEntity.verfiedByUser;
        return this;
    }
}
